<template>
  <div class="help-drawer-box">
    <el-drawer class="news" :visible.sync="dialogVisible" direction="rtl" id="help-cont" :modal-append-to-body="false" custom-class="help-drawer">
      <div class="container" :class="isShow ? 'show' : 'hide'">
        <div class="index_module_head">
          <span class="head_span heaper-world">{{ $i18.language('帮助中心') }}</span>
          <span class="close" @click="goClose"><i class="el-icon-close"></i></span>
        </div>
        <div style="min-height: 450px" v-loading="loading">
          <div class="heaper-top-box">        
          <div class="all-documents-text">{{ $i18.language('全部文档')}}</div>
          <div class="heaper-card-box">
            <div class="left-box">
             <p class="desc1">{{ $i18.language('使用时常见的问题')}}</p>
             <p class="desc2">{{ $i18.language('在文档中找答案')}}</p>
             <el-button size="mini" :class="['show-button-style btn-height-28 readMe-btn',lang=='en'?'en-readMe-btn':'zh-readMe-btn']" @click="readMe">{{ $i18.language('查看')}}</el-button>
           </div>
          </div>
          </div>
          <div v-if="detailList && detailList.length > 0 && !loading">
            <div class="container-body" :style="{ height: `${screenHeight}` }">
              <div class="style_module_list" v-if="videoList && videoList.length > 0">
                <div class="heaper-world heaper-world-c">{{ $i18.language('帮助视频') }}</div>
                <div class="video-style">
                  <el-carousel trigger="click" height="200px">
                    <el-carousel-item v-for="(item, index) in videoList" :key="index">
                      <div class="title-show">{{ item.title }}</div>
                      <span class="videoIcon" @click="clickVideo(item)"><svg-icon name="videoL"></svg-icon></span>
                      <img style="width: 304px" :src="item.thumb" alt="" @click="clickVideo(item)" />
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div class="style_module_list" v-if="helpList && helpList.length > 0">
                <div class="heaper-world heaper-world-c">{{ $i18.language('帮助文档') }}</div>
                <ul class="style_module_group">
                  <li v-for="(item, idx) in helpList" :key="idx" @click="goDetailsCont(item)">
                    <span class="style_module_item_text">{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- !isShow -->

      <div class="container" v-if="!isShow">
        <div class="index_module_head">
          <span @click="goBack" class="go-back">
            <i class="el-icon-arrow-left"></i>
            <span class="head_span">{{ $i18.language('返回') }}</span>
          </span>
          <span class="close" @click="goClose"><i class="el-icon-close"></i></span>
        </div>
        <div class="style_modul_detail">
          <div class="title">{{ detailCurrent.title }}</div>
          <!-- 读取相应的  md 文档 -->
          <div class="h-style markdown-body">
            <div v-html="detailCurrent.mdDesc ? detailCurrent.mdDesc : detailCurrent.htmlDesc"></div>
          </div>
        </div>
      </div>
      <div class="maskLayer" @click="goClose"></div>
    </el-drawer>
    <!-- //当前视频弹窗 -->
    <help-video ref="helpVideo" :currentVideo="currentVideo" @clearVideo="clearVideo"></help-video>
  </div>
</template>
<script>
import axios from 'axios'
import empty from '@/components/empty.vue'
import helpVideo from './helpVideo.vue'
export default {
  components: {
    empty,
    helpVideo,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      isShow: true,
      detailList: [],
      videoList: [],
      helpList: [],
      detailCurrent: {},
      currentVideo: {},
      openStatus: true,
      helpAllDoc:'',
      lang:localStorage.getItem('language')
    }
  },

  created() {
  },
  computed: {
    screenHeight() {
      return document.body.clientHeight - 108 + 'px'
    },
  },
  watch: {},
  methods: {
    readMe() {
      if (this.$util.isLogin()) {
        let docUrl=''
        let language = localStorage.getItem('language')=='en'?'en':''
        docUrl= this.$util.getCurrentWebSite() +  `/help/index.html#/gt/${language}`
        window.open(docUrl,'_blank') 
      }
    },
    //当前文档的接口
    goDetails(id) {
      let pageUnionID = this.$util.getPageUnionID().includes('gt6_user') ? 'gt6_user' : this.$util.getPageUnionID()
      if (this.openStatus) {
        this.loading = true
        this.$api.help.getProductHelpList({ onlyKey: pageUnionID }).then((res) => {
          if (res && res.code == 200) {
            this.loading = false
            this.detailList = res.data
            if (this.detailList && this.detailList.length > 0) {
              this.detailList.forEach((item) => {
                if (item.appKey == 'GT6_Video_Helper') {
                  this.videoList.push(item)
                }
                if (item.appKey == 'GT6_Doc_Help') {
                  this.helpList.push(item.title)
                }
              })
            }
            this.openStatus = false
          }
        })
      }
    },
    goDetailsCont(item) {
      let detailListChange = JSON.parse(JSON.stringify(this.detailList))
      this.detailCurrent = detailListChange.find((i) => {
        if (i.title == item && i.appKey == 'GT6_Doc_Help') {
          if (i.mdDesc) {
            i.mdDesc = this.Marked.parse(i.mdDesc)
          }
          return i
        }
      })
      this.isShow = false
    },
    goClose() {
      this.dialogVisible = false
      this.isShow = true
      this.detailList = []
      this.videoList = []
      this.helpList = []
      this.openStatus = true
    },
    goBack() {
      this.isShow = true
      this.detailCurrent = {}
    },
    clickVideo(item) {
      //当前视频点击播放
      this.currentVideo = item
      this.$refs.helpVideo.open()
      this.$forceUpdate()
    },
    clearVideo() {
      this.currentVideo = {}
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.news {
  top: 60px;
  .el-drawer__open {
    .el-drawer {
      width: 369px !important;
    }
    .el-drawer__header {
      display: none;
    }
  }

  .el-drawer__body {
    display: flex;
    flex-direction: column;
    // overflow: hidden;
    padding-bottom: 10px;
  }
  .clearAll {
    color: $--color-primary-6;
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
@import './markdown.css';
.news {
  // position: fixed;
  // top: 60px;
  // right: 0px;
  // z-index: 2000;
  // width: 369px;
  // height: calc(100% - 60px);
  // line-height: 24px;
  // font-size: 14px;
  // box-sizing: content-box;
  // &.show {
  //   display: block;
  // }
  // &.hide {
  //   display: none;
  // }
  .container {
    width: 100%;
    height: 100%;
    background: #fff;
    box-shadow: 0 6px 18px #1d293924;
    position: relative;
    z-index: 1;
    &.show {
      display: block;
    }
    &.hide {
      display: none;
    }
    .index_module_head {
      width: calc(100% - 24px);
      height: 46px;
      background: #f9fafb;
      box-shadow: inset 0 -1px #e4e4e5;
      padding: 0px 0px 0px 24px;
      position: relative;
      z-index: 1;
      color: #1f2126;
      .head_span {
        display: inline-block;
        margin-top: 15px;
      }
      .close {
        position: absolute;
        right: 0px;
        padding-top: 12px;
        padding-right: 24px;
        font-size: 18px;
      }
    }
    .style_module_list {
      padding: 20px 24px;
      overflow-y: overlay;
      overflow-x: hidden;
      border-bottom: 1px solid $--border-color-primary-6;
      flex: 1;
      width: calc(100% - 48px);
      font-size: 14px;
      font-weight: 500;
      h4 {
        margin-top: 16px;
        margin-bottom: 16px;
      }
      .style_module_group {
        text-align: justify;
        width: 320px;
        overflow: hidden;
        li {
          margin-top: 8px;
          width: calc(100% - 4px);
          line-height: 22px;
          max-height: 46px;
          text-align: justify;
          overflow: hidden;
          padding: 2px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-wrap: break-word;
          word-break: break-all;
          list-style-type:none;
          .style_module_item_text {
            cursor: pointer;
            color: #2878ff;
            display: inline;
            border-bottom: 1px solid transparent;
          }
          .style_module_item_text:hover {
            color: #4e95ff;
            border-bottom: 1px solid #4e95ff;
          }
        }
      }
    }

    .style_modul_detail {
      padding: 24px 32px 24px 24px;
      .title {
        font-size: 22px;
        font-weight: 500;
        color: #2f2e3f;
        line-height: 32px;
        padding-bottom: 24px;
      }
    }
  }
  .maskLayer {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
  }
  .heaper-top-box{
    padding:20px;
    border-bottom: 1px solid #e5e5e5;
    .all-documents-text{
      margin-bottom: 20px;
      color: #1A173B;
      font-size: 14px;
    }
    .readMe-btn{
       width: 68px;
       margin-top:35px;
    }
    .en-readMe-btn{
      margin-top: 20px;
    }
    .zh-readMe-btn{
      margin-top: 35px;
    }

  }
  .heaper-card-box{
    height: 159px;
    width:auto;
    background-image: url('../../assets/help/bg-card@2x.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    display:flex;
    align-items: center;
    justify-content: space-between;
    .left-box{
      width: 50%;
      margin-left: 19px;
      .desc1{
        color: $--color-title;
        font-size: 14px;
        margin:5px 0 15px 0;
      }
      .desc2{
        color: $--color-font-light;
        font-size: 12px;
      }
    }
  }
  .heaper-world {
    font-size: 14px;
    color: #1a173b;
  }
  .video-style {
    width: 100%;
    margin-top: 20px;
    video {
      border-radius: 8px;
    }
  }
  .heaper-world-c {
    // margin-bottom: 20px;
  }
  .container-body {
    // background: green;
    // height: 500px;
    overflow-y: auto;
  }
  .go-back {
    cursor: pointer;
  }
  // .h-style h1 {
  //   margin-bottom: 10px;
  // }
  // .h-style h2 {
  //   margin-bottom: 10px;
  // }
  .title-show {
    position: absolute;
    left: 15px;
    top: 20px;
  }
  .videoIcon {
    font-size: 50px;
    position: absolute;
    top: 62px;
    left: 127px;
    cursor: pointer;
  }
  .close {
    cursor: pointer;
  }
}
.ceshi {
  cursor: pointer;
  color: #0e99eb!important;
  margin-top: 20px;
  margin-left:24px;
}
.help-drawer-box{
 .v-modal{
    position: absolute !important;
  }
}
</style>
